module.exports = __webpack_public_path__ + "img/framboise_namelaka_cooked.314ee64d.jpg";